import "./App.css";
import { Route, Routes } from "react-router-dom";
import MalariaSurvey from "./surveys/malaria-survey/MalariaSurvey";
import ModalDrop from "./components/modalDrop";
import { useContext } from "react";
import { contextContainer } from "./Context";
import Loading from "./components/Loading";
import TropicalNatural from "./surveys/tropical-natural/TropicalNatural";
import MomsPride from "./surveys/moms-pride/MomsPride";
import RainOil from "./surveys/rainoil/RainOil";
import MISSurvey from "./surveys/mis-survey/MISSurvey";
import WelcomePPMV from "surveys/ppmvs/WelcomePpmv";
import MISLongSurvey from "pages/mis-long-survey";
import SurveyPage from "pages/mis-long-survey/SurveyPage";
import RewardPage from "pages/reward/RewardPage";
import ThankyouPage from "pages/reward/Thankyou";
import ACTSurvey from "pages/act-survey/ACTSurvey";
import ACTSurveyUAT from "pages/act-uat/ACTSurveyUAT";
import SolinaSurveyDev from "pages/solina-survey-dev/SolinaSurveyDev";
import SolinaWelcomePage from "pages/solina-survey-dev/SolinaWelcomePage";
import SolinaPPMVDev from "pages/solina-survey-dev/SolinaPPMVDev";
import WelcomePPMVPage from "pages/solina-survey-dev/WelcomeSolinaPPMV";
import SolinaThankyouPage from "pages/reward/SolinaThankyou";
import MSDConsumerWelcomePage from "pages/msd-survey/MSDConsumer";
import MSDConsumerSurvey from "pages/msd-survey/MSDSurvey";
import MSDProviderWelcomePage from "pages/msd-survey/MSDProvider";
import MSDProviderSurvey from "pages/msd-survey/MSDProviderSurvey";
import WelcomePPMVNewPage from "pages/solina-survey-dev/WelcomePPMVNew";

function App() {
	const { loading } = useContext(contextContainer);
	return (
		<>
			{loading && (
				<ModalDrop>
					<Loading />
				</ModalDrop>
			)}

			<Routes>
				<Route path="/" element={<MalariaSurvey />} />
				<Route path="/tropical" element={<TropicalNatural />} />
				<Route path="/moms-pride" element={<MomsPride />} />
				<Route path="/rainoil" element={<RainOil />} />
				<Route path="/m-old" element={<MISSurvey />} />
				<Route path="/ppmv" element={<WelcomePPMV />} />
				<Route path="/m" element={<MISLongSurvey />} />
				<Route path="/ml-participant" element={<SurveyPage />} />
				<Route path="/ml-reward" element={<RewardPage />} />
				<Route path="/ml-thank-you" element={<ThankyouPage />} />
				<Route
					path="/solina-thank-you"
					element={<SolinaThankyouPage />}
				/>
				<Route path="/act" element={<ACTSurvey />} />
				<Route path="/act-uat" element={<ACTSurveyUAT />} />
				<Route path="/solina-d" element={<SolinaSurveyDev />} />
				<Route path="/solina-p" element={<SolinaPPMVDev />} />
				<Route
					path="/solina-welcome-ppmv"
					element={<WelcomePPMVPage />}
				/>

				<Route
					path="/solina-welcome-ppmv-new"
					element={<WelcomePPMVNewPage />}
				/>
				<Route path="/solina-welcome" element={<SolinaWelcomePage />} />
				<Route
					path="/msd-welcome"
					element={<MSDConsumerWelcomePage />}
				/>
				<Route path="/msd-survey" element={<MSDConsumerSurvey />} />

				<Route
					path="/msd-provider-welcome"
					element={<MSDProviderWelcomePage />}
				/>
				<Route
					path="/msd-provider-survey"
					element={<MSDProviderSurvey />}
				/>
			</Routes>
		</>
	);
}

export default App;
